module.exports = __webpack_public_path__ + "static/media/test-prep.89439a50.svg";